import React from 'react';
import {
  focusEditor,
  useEventPlateId,
  useEditorState,
} from '@udecode/plate-common';
import { ELEMENT_OL, getListItemEntry, toggleList } from '@udecode/plate-list';

import { BlockToolbarButton } from './BlockToolbarButton';

export const ListToolbarButton = ({
  id,
  type = ELEMENT_OL,
  ...props
}) => {
  const editor = useEditorState(useEventPlateId(id));

  const res = !!editor?.selection && getListItemEntry(editor);

  return (
    <BlockToolbarButton
      active={!!res && res.list[0].type === type}
      type={type}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        toggleList(editor, { type });
        setTimeout(() => {
          focusEditor(editor);
        }, 0);
      }}
      {...props}
    />
  );
};